import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useHeaderUnAuthStyles = makeStyles((theme: Theme) => ({
  container: {
    textAlign: "center",
  },
}));
